import * as React from "react";
import { useResource, Resources } from "Translations/Resources";
import { AccessRightCodes } from "Components/Models/AccessRights";
import { SubMenu, SubMenuItem } from "Components/Shared/Menu/SubMenu";
import { useHasCurrentUserAccessRight } from "Hooks/useHasCurrentUserAccessRight";

type Props = {
  accessRight?: AccessRightCodes[];
};

export const SettingsSubMenu: React.FunctionComponent<Props> = props => {
  const { accessRight } = props;
  const { t } = useResource();
  const hasAccessRight = useHasCurrentUserAccessRight();

  const menuItems: SubMenuItem<true>[] = [
    {
      name: t(Resources.Users.Title),
      url: `/${t(Resources.Routes.Users)}`,
    },
    {
      name: t(Resources.AccessRoles.Title),
      url: `/${t(Resources.Routes.AccessRoles)}`,
    },
  ];

  if (hasAccessRight([AccessRightCodes.Core_InvoiceItemCategories_Read])) {
    menuItems.push({
      name: t(Resources.InvoiceItemCategories.Title),
      url: `/${t(Resources.Routes.InvoiceItemCategories)}`,
    });
  }

  return (
    <SubMenu menuItems={menuItems} accessRight={accessRight} isHorizontal />
  );
};
